import e from "../../utils/classNames.js";
import t from "../collapse/Collapse.js";
import { useState as n } from "react";
import { noop as r } from "es-toolkit/function";
import { jsx as i, jsxs as a } from "react/jsx-runtime";
//#region src/components/expander/ExpanderPanel.tsx
var o = (o) => {
	let { open: s = !1, iconLeft: c = !1, bsStyle: l = "blank", title: u, headerClassName: d, titleClassName: f, bodyClassName: p, iconClassName: m, unmountOnExit: h = !0, onEntered: g = r, onExited: _ = r, onAnimationStart: v = r, onToggle: y = r, className: b, trackingAttributes: x, children: S, ...C } = o, [w, T] = n(s), [E, D] = n(s);
	E !== s && (T(s), D(s));
	let O = () => {
		let e = !w;
		T(e), y(e);
	}, k = e("expander-panel panel", `panel-${l}`, b), A = e("expander-icon", m, "uikit-icon", "icon-chevron-down"), j = e("panel-heading", w && "open", c && "icon-left", d && d), M = e("title", f && f), N = e("panel-body", p && p), P = S && typeof S == "function";
	return /* @__PURE__ */ a("div", {
		...C,
		className: k,
		"aria-label": "expander panel",
		children: [/* @__PURE__ */ a("div", {
			className: j,
			onClick: O,
			"aria-label": "panel heading",
			...x,
			children: [
				/* @__PURE__ */ i("span", {
					className: M,
					children: u
				}),
				/* @__PURE__ */ i("span", { className: A }),
				l === "separator" && /* @__PURE__ */ i("div", {
					className: "separator",
					children: /* @__PURE__ */ i("hr", {})
				})
			]
		}), /* @__PURE__ */ i(t, {
			open: w,
			unmountOnExit: h,
			onEntered: g,
			onExited: _,
			onAnimationStart: () => v(),
			children: /* @__PURE__ */ i("div", { children: /* @__PURE__ */ i("div", {
				className: N,
				children: P ? S(w) : S
			}) })
		})]
	});
};
//#endregion
export { o as default };

//# sourceMappingURL=ExpanderPanel.js.map